import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Button, Typography } from "@mui/material";

import { useDialog } from "../../../../../common/components/dialog/useDialog";
import CreateSKUDialog from "./CreateSKUDialog";

const CreateSKUDialogContainer = (): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<AddOutlinedIcon />}
        onClick={handleDialogOpen}
      >
        <Typography variant="buttonMedium">Create SKU Configuration</Typography>
      </Button>

      {open && <CreateSKUDialog open={open} handleClose={handleDialogClose} />}
    </>
  );
};

export default CreateSKUDialogContainer;
